import styled from '@mui/material/styles/styled';

export const Root = styled('div')(({ theme }) => ({
  flexShrink: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  background: '#fff',
  overflowY: 'auto',
  ...theme.scrollbars.default
}));